import { render, staticRenderFns } from "./_confirmOrderStep.vue?vue&type=template&id=d1f231b2"
import script from "./_confirmOrderStep.vue?vue&type=script&lang=js"
export * from "./_confirmOrderStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports